import React from "react";

function Switch({ children, exp }) {
    return React.Children.map(children, child => {
        if (exp === child.props.case) {
            return child
        }
    })
}
 
export default Switch;